<template>
  <div class="main_div">
    <section id="container" class="gnb_pdt">
      <div class="title_wrap">
        <h1 class="f_l">운송장 번호 관리</h1>
      </div>
      <div class="contents_wrap">
        <div class="content_list">
          <div class="button_wrap_area">
            <ul>
              <li>
                <button class="large_btn orange" @click="commonOnChangeEvent">검색</button>
              </li>
              <li>
                <button class="large_btn" @click="cleanFilter">초기화</button>
              </li>
            </ul>
          </div>
          <div id="filter_section" class="filter_wrap">
            <ul class="filter_list">
              <li class="col2">
                <dd>
                  <label>사업장</label>
                  <ul>
                    <li>
                      <kendo-dropdownlist
                          ref="facilityRef"
                          :data-source="zone1DepthList"
                          :data-text-field="'cdNm'"
                          :data-value-field="'cdId'"
                          :option-label="'전체'"
                          :no-data-template="'표시할 데이터가 없습니다.'"
                          class="w100"
                          @change="commonOnChangeEvent"
                      >
                      </kendo-dropdownlist>
                    </li>
                  </ul>
                </dd>
                <dd>
                  <label>운송장 번호</label>
                  <ul>
                    <li>
                      <kendo-maskedtextbox
                          class="w100"
                          ref="blNoRef"
                          id="blNo"
                          :placeholder="'운송장 번호를 입력하세요'"
                      >
                      </kendo-maskedtextbox>
                    </li>
                  </ul>
                </dd>
              </li>
              <li class="col2">
                <dd>
                  <label>등록일</label>
                  <ul>
                    <li>
                      <div class="fl k-widget k-daterangepicker k-state-default w100" data-role="daterangepicker"
                           role="combobox" aria-expanded="false" autocomplete="off">
                        <kendo-datepicker
                            ref="frstRgstDtStartDtRef"
                            :max="maxDate"
                            :placeholder="'년/월/일'"
                            :format="'yyyy/MM/dd'"
                            @change="commonOnChangeEvent"
                        >
                        </kendo-datepicker>
                        <span>&nbsp;</span>
                        <kendo-datepicker
                            ref="frstRgstDtEndDtRef"
                            :max="maxDate"
                            :placeholder="'년/월/일'"
                            :format="'yyyy/MM/dd'"
                            @change="commonOnChangeEvent"
                        >
                        </kendo-datepicker>
                      </div>
                    </li>
                  </ul>
                </dd>
                <dd>
                  <label>사용 여부</label>
                  <ul>
                    <li>
                      <kendo-buttongroup
                          ref="inUseYnRef"
                          :index="computedInUseYn"
                          @select="commonOnChangeEvent"
                          :style="{width: '100%', border: '0'}"
                      >
                        <kendo-buttongroup-button
                            v-for="item in inUseYnList"
                            v-bind:key="item.cdId"
                        >
                          {{ item.cdNm }}
                        </kendo-buttongroup-button>
                      </kendo-buttongroup>
                    </li>
                  </ul>
                </dd>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="dblock mgt20">
        <div class="c_t_button_wrap fr">
          <button class="mid_btn mr5" @click="onClickUplaod">
            <i class="download_icon"></i>
            <span>운송장 번호 등록(엑셀)</span>
          </button>
        </div>
      </div>
      <kendo-grid ref="blNoListGridRef"
                  style="cursor: auto;"
                  class="basic_table mt10"
                  :data-source="blNoDataSource"
                  :columns="blNoListColumns"
                  :navigatable="true"
                  :filterable="false"
                  :sortable="true"
                  :scrollable="true"
                  :pageable-always-visible="true"
                  :pageable-page-sizes="[5, 10, 20, 50, 100, 500, 1000]"
                  :reorderable="true"
                  :column-menu="false"
                  :resizable="true"
                  :selectable="'multiple row'"
                  :noRecords="{ template: '<div class=\'gridNoData\' style=\'text-align: center;\'>표시할 데이터가 없습니다.</div>' }">
      </kendo-grid>
    </section>
    <bl-no-excel-upload-window
        ref="uploadWindowRef"
    ></bl-no-excel-upload-window>
  </div>
</template>

<script>
import EtnersParseUtil from "@/common/etners.parse.util";
import ApiConfig from "@/api/api.config";
import EtnersDateTimeUtil from "@/common/etners.datetime.util";

import BlNoExcelUploadWindow from "@/components/blno/BlNoExcelUploadWindow";
import {ZoneMixin} from "@/mixin/Mixin";

export default {
  name: "blNoList",
  mixins: [ZoneMixin],
  components: {BlNoExcelUploadWindow},
  created() {
    const vm = this
    vm.getBlNoList()
  },
  mounted() {
    const vm = this

    //엔터키 이벤트 자동 세팅
    const enterkeyEventTargetIdArray = [
      'blNo'
    ]

    for (const elementId of enterkeyEventTargetIdArray) {
      const element = document.getElementById(elementId)
      if (element !== undefined) {
        element.onkeyup = function (e) {
          const ENTER_KEY_CODE = 'Enter'
          const NUM_PAD_ENTER = 'NumpadEnter'
          const currentKeyCode = e.code

          if (currentKeyCode === ENTER_KEY_CODE || currentKeyCode === NUM_PAD_ENTER) {
            vm.commonOnChangeEvent(e)
          }
        }
      }
    }
    vm.$refs.frstRgstDtEndDtRef.kendoWidget().value(vm.maxDate)
  },
  computed: {
    computedInUseYn () {
      const inUseYn = null
      if (inUseYn === undefined || inUseYn === null) {
        return 0
      } else {
        if (inUseYn === 'Y') return 1
        else if (inUseYn === 'N') return 2
        else return 0
      }
    }
  },
  methods: {
    getBlNoList () {
      const vm = this
      vm.blNoDataSource = new kendo.data.DataSource({

        name: 'blNoDataSource',
        page: 1,
        pageSize: 10,
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        transport: {
          read: {
            url: `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/blno/blNoList.json`,
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            cache: false
          },
          parameterMap: function(options, operation) {
            if (operation === 'read') {

              const paramToKendoFilters = vm.currentPageFilterOption()
              const params = {
                loginUserToken: vm.loginUserToken,
                skip: options.skip,
                take: options.take,
                sort: options.sort,
                page: options.page,
                pageSize: options.pageSize,
                ...paramToKendoFilters
              }

              sessionStorage.setItem('LAST_ROUTE_PARAMS', kendo.stringify(params))
              return kendo.stringify(params)
            }

            if (operation !== 'read' && options.models) {
              return {models: kendo.stringify(options.models)}
            }
          }
        },
        schema: {
          type: 'json',
          parse: function(response) {
            if (response.resultStatus.messageCode !== '2000') {
              kendo.alert('message: ' + response.resultStatus.messageText)
              return ''
            }

            const changeResultData = response.resultData
            let rowNumber = response.total > 1 ? response.total - ((vm.$refs.blNoListGridRef
                .dataSource.page() - 1) * vm.$refs.blNoListGridRef.dataSource.pageSize()) : response.total

            if (changeResultData === null) {
              return false
            }

            for (let i = 0; i < changeResultData.length; i++) {
              const row = changeResultData[i]
              // row 번호 내림차순 셋팅
              row.rowNumber = rowNumber--
            }

            //status 상태 값 받아오기
            response.resultData = changeResultData
            return response
          },

          total: function(response) {
            return response.total
          },

          data: function(response) {
            // 카테고리 seq 순으로 배열 선언
            if (response.resultStatus.messageCode === '2000') {
              return response.resultData
            } else {
              kendo.alert('message: ' + response.resultStatus.messageText)
              return ''
            }
          }
        },
        error: function(e) {
          // console.log('error event handler', e.errors)
        }
      })
    },

    commonOnChangeEvent () {
      const vm = this
      const gridRefs = this.$refs.blNoListGridRef

      if (gridRefs !== undefined && gridRefs.kendoWidget() !== undefined) {
        if (vm.lastRouteParams === undefined || vm.lastRouteParams.page === undefined) {
          gridRefs.kendoWidget().dataSource.page(1)
        } else {
          gridRefs.kendoWidget().dataSource.read()
          this.lastRouteParams.page = undefined
        }
      }
    },

    cleanFilter () {
      const vm = this
      const refs = vm.$refs

      if (!!refs.facilityRef) {
        refs.facilityRef.kendoWidget().value('')
      }
      if (!!refs.blNoRef) {
        refs.blNoRef.kendoWidget().value('')
      }
      if (!!refs.frstRgstDtStartDtRef) {
        refs.frstRgstDtStartDtRef.kendoWidget().value('')
      }
      if (!!refs.frstRgstDtEndDtRef) {
        refs.frstRgstDtEndDtRef.kendoWidget().value('')
      }
      if(!!refs.inUseYnRef) {
        refs.inUseYnRef.kendoWidget().select(0)
      }

      vm.commonOnChangeEvent()
    },

    currentPageFilterOption () {
      const vm = this
      const refs = vm.$refs
      let currentSearchDataObj = {}

      if(refs.facilityRef !== undefined){
        const facility = refs.facilityRef.kendoWidget().value()
        if(facility !== null && facility !== ''){
          currentSearchDataObj.facility = facility
        }
      }
      if(refs.blNoRef !== undefined){
        const blNo = refs.blNoRef.kendoWidget().value()
        if(blNo !== '' && blNo !== null){
          currentSearchDataObj.blNo = blNo.trim()
        }
      }
      if(refs.frstRgstDtStartDtRef !== undefined){
        const frstRgstDtStartDt = refs.frstRgstDtStartDtRef.kendoWidget().value()
        if(!!frstRgstDtStartDt){
          currentSearchDataObj.frstRgstDtStartDt = EtnersDateTimeUtil.dateToYYYYMMDDWithPoint(frstRgstDtStartDt, '/')
        }
      }
      if(refs.frstRgstDtEndDtRef !== undefined){
        const frstRgstDtEndDt = refs.frstRgstDtEndDtRef.kendoWidget().value()
        if(!!frstRgstDtEndDt){
          currentSearchDataObj.frstRgstDtEndDt = EtnersDateTimeUtil.dateToYYYYMMDDWithPoint(frstRgstDtEndDt, '/')
        }
      }
      if(refs.inUseYnRef !== undefined){
        const inUseYn = refs.inUseYnRef.kendoWidget().current().index()
        if (inUseYn !== '' && inUseYn !== null) {
          currentSearchDataObj.inUseYn = vm.inUseYnList[inUseYn].cdId
        }
      }

      return currentSearchDataObj

    },

    onClickUplaod () {
      const vm = this
      vm.$refs.uploadWindowRef.$refs.kendoWindowRef.kendoWidget().center().open()
    },
  },
  data () {
    const kendoGridHeaderAttributes = {
      style: 'font-weight: bold; text-align : center;'
    }

    const now = new Date()

    return {
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      inUseYnList : [{cdId:null, cdNm:'전체'}, {cdId:'Y', cdNm:'사용'}, {cdId:'N', cdNm:'미사용'}],
      maxDate : now,

      blNoDataSource: [],
      blNoListColumns: [
        {
          field: 'rowNumber',
          title: 'No.',
          width: '2%',
          sortable: false,
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
        },
        {
          field: 'facilityNm',
          title: '사업장',
          width: '6%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
          template(dataItem) {
            return EtnersParseUtil.convertEmptyStringToSeparator(dataItem.facilityNm)
          }
        },
        {
          field: 'blNo',
          title: '운송장 번호',
          width: '6%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'inUseYn',
          title: '사용 여부',
          width: '5%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
          template(dataItem) {
            if(dataItem.inUseYn === 'Y') return '사용'
            else return '미사용'
          }
        },
        {
          field: 'frstRgstId',
          title: '등록자',
          width: '6%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'frstRgstDt',
          title: '등록일시',
          width: '7%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
        },
      ]
    }
  }
}
</script>

<style scoped>

</style>
